export default __webpack_public_path__ + "static/media/016-gas-station.ceee0d88.png";